import { render } from "./Kontakt.vue?vue&type=template&id=e276e36e"
import script from "./Kontakt.vue?vue&type=script&lang=ts"
export * from "./Kontakt.vue?vue&type=script&lang=ts"

import "./Kontakt.vue?vue&type=style&index=0&id=e276e36e&lang=scss"
script.render = render

export default script